import { FC, useRef } from 'react';
import { useVariableValue } from '@devcycle/react-client-sdk';

import { Popover } from '../Popover';
import { LoginListMenu } from '../LoginListMenu';
import { HEADER } from '../../consts';
import { pushGTMEvent } from '../../utilities';
import { Button } from '../Button';
import { useRequiredContent, HeaderContent, OpCoContent } from '../services/content';
import { useUIString } from '../services/content/hooks/useUIString';

export interface UserActionsProps {
  logInUrl?: string;
  onLoginClick: (opcoid: string) => void;
}

export const UserActions: FC<UserActionsProps> = ({ logInUrl, onLoginClick }) => {
  const {
    data: { registerLabel, registerUrl, signInLabel },
  } = useRequiredContent(HeaderContent);
  const {
    data: { id: currentOpCo },
  } = useRequiredContent(OpCoContent);
  const signInDropdownAriaLabel = useUIString('signInDropdownAriaLabel');
  const multiOpcoFlag = useVariableValue('multi-opco-login', false);

  const relativeRef = useRef<HTMLSpanElement | null>(null);

  return (
    <>
      {multiOpcoFlag ? (
        <span ref={relativeRef}>
          <Popover
            placement="bottom right"
            closeDelay={600}
            openDelay={300}
            relRef={relativeRef}
            offset={24}
            trigger={
              <Button size="md" emphasis="quaternary" styleVariant="accent" disableRouting>
                {signInLabel}
              </Button>
            }
            aria-label={signInDropdownAriaLabel}
            isNonModal
          >
            <LoginListMenu loginUrl={logInUrl} onLoginClick={onLoginClick} />
          </Popover>
        </span>
      ) : (
        <Button size="md" emphasis="quaternary" styleVariant="accent" onPress={() => onLoginClick(currentOpCo)} href={logInUrl} disableRouting>
          {signInLabel}
        </Button>
      )}
      <Button
        href={registerUrl}
        size="md"
        emphasis="primary"
        styleVariant="accent"
        onPress={() => pushGTMEvent(HEADER, registerLabel)}
        disableRouting
      >
        {registerLabel}
      </Button>
    </>
  );
};
